import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { ModalComponent } from '../modal.component';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss']
})
export class ConfirmPopUpComponent extends ModalComponent implements OnInit, OnDestroy {
  @Input() title: string = '';
  @Input() eventBroadcast: string = '';
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
}
